// extracted by mini-css-extract-plugin
export var bubble = "_3f-0";
export var container = "_3f-3";
export var contrastBorder = "_3f-4";
export var greyOut = "_3f-2";
export var initialsWrapper = "_3f-1";
export var large = "_3f-9";
export var medium = "_3f-8";
export var mediumSmall = "_3f-7";
export var mediumSmallMedium = "_3f-c";
export var micro = "_3f-5";
export var small = "_3f-6";
export var tiny = "_3f-b";
export var xTiny = "_3f-a";